import type { UserSettingType } from './generated/graphql'
import {
  DeleteMySettingDocument,
  GetMySettingDocument,
  GetMySettingLimitDocument,
  ListMySettingsDocument,
  UpsertMySettingDocument,
} from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  modifyQueryHook,
} from './utils'

// This file and graphql query are named "setting",
// but this is not the per user global setting
// Per user global setting is preference
// This is actually notes and quality tags presets created by user

export const useGetMySetting = modifyQueryHook(
  createQueryHook(GetMySettingDocument),
  {
    transform: (id: string) => ({ id }),
    reduce: r => r?.setting,
  },
)

export const useListMySettings = modifyQueryHook(
  createQueryHook(ListMySettingsDocument),
  {
    reduce: r => r?.me?.settings,
  },
)

export const fetchListMySettings = createFetchQueryHelper(
  ListMySettingsDocument,
)

export const useGetMySettingLimit = modifyQueryHook(
  createQueryHook(GetMySettingLimitDocument),
  {
    transform: (type: UserSettingType) => ({ type }),
    reduce: r => r?.me?.settingLimit,
  },
)

export const [useUpsertMySetting, executeUpsertMySetting] =
  createMutationHelper(UpsertMySettingDocument)

export const [useDeleteMySetting, executeDeleteMySetting] =
  createMutationHelper(DeleteMySettingDocument)
